import { render, staticRenderFns } from "./ListaComprador.vue?vue&type=template&id=7691eace"
import script from "./ListaComprador.vue?vue&type=script&lang=js"
export * from "./ListaComprador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports